import React from "react";
import useFetch from "../../hooks/useFetch";
import LoadingCard from "../../elements/LoadingCard";
import EspCard from "./EspCard";
import EspErrorCard from "./EspErrorCard";

export default function TotalSales() {
  const { isLoading, data, error } = useFetch("total-sales");

  if (isLoading) return <LoadingCard />;

  if (error) {
    return (
      <EspErrorCard error={error}>
        <EspErrorCard.LineChart />
        <EspErrorCard.ChartCopy />
      </EspErrorCard>
    );
  }

  return (
    <EspCard data={data} tag={<EspCard.CurrencyTag />}>
      <EspCard.Section>
        <EspCard.LineChart />
        <EspCard.Copy>
          <EspCard.FeaturedDataPoint /> <span>WAC 340B Total Sales</span>
        </EspCard.Copy>
        <EspCard.Interval />
      </EspCard.Section>
    </EspCard>
  );
}
